module.exports = __webpack_public_path__ + "img/pic_jiance.5b452bca.png";